module.exports = __webpack_public_path__ + "img/eden-egreso-total.b98bd22b.svg";